import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => ({
  footer: {
    left: '0px',
    right: '0px',
    bottom: '0px',
    position: 'fixed',
    padding: `${spacing(4.5)}px ${spacing(5)}px ${spacing(7.5)}px ${spacing(5)}px`,
    backgroundColor: palette.background.default,
    boxShadow: `0px -1px 5px ${palette.background.contrastShadow}`,
    borderRadius: '10px 10px 0px 0px',
    zIndex: 2,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
